import { Flex, OnboardingLayout } from "@wayflyer/flyui";
import { useIntl } from "react-intl";

import { IncompleteStepsModal } from "../../../components/incomplete-steps-modal";
import { UploadDocumentType } from "../../../types";
import { PoolBancarioDocumentUpload, useDocumentNavigationActions, MESSAGES } from "../components";

export const PoolBancarioDocumentUploadPage = () => {
  const intl = useIntl();

  const { primaryAction, secondaryAction, applicationSubmit, documentError } = useDocumentNavigationActions({
    forType: UploadDocumentType.POOL_BANCARIO,
  });

  return (
    <>
      <IncompleteStepsModal {...applicationSubmit} />
      <OnboardingLayout
        variant="wide"
        title={intl.formatMessage(MESSAGES.poolBancarioTitle)}
        actions={{ primary: primaryAction, secondary: secondaryAction }}
      >
        <Flex maxWidth="550px">
          <PoolBancarioDocumentUpload error={documentError} />
        </Flex>
      </OnboardingLayout>
    </>
  );
};
